import { Component, ChangeDetectionStrategy } from '@angular/core';
import {Session} from "../../../services/session.service";
import { HeaderComponent } from '../header/header.component';
import { FooterComponent } from '../footer/footer.component';

@Component({
    selector: 'app-page-not-found',
    templateUrl: './page-not-found.component.html',
    styleUrls: ['./page-not-found.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [HeaderComponent, FooterComponent]
})
export class PageNotFoundComponent {

  isFaculty: boolean = false;
  constructor(private session: Session) { }
}
